module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-hant-dark-e54c6a0a822d239fcc89e1d5742e34ba.jpg";